import React from 'react'
import PropTypes from 'prop-types'
import ShowHideMore from './ShowHideMore'

import './index.scss'

const ActiveFilters = ({ filters, labels }) => {
  const getValues = (items) => {
    return <ShowHideMore keys={items} hide={labels.hide} />
  }
  const getKeys = () => {
    const filterObjects = Object.keys(filters)

    return filterObjects.map((id, n) => (
      <div className='filter-info' key={`active-${id}`}>
        <span className='filter-list'>
          <span className='filter-title'>{id}:</span>
          {getValues(filters[id])}
          {n !== filterObjects.length - 1 && <span>|</span>}
        </span>
      </div>
    ))
  }

  return (
    <div id='active-filters-box'>
      <h4 id='active-filters-title'>{labels.title}</h4>
      {labels?.subtitle && (
        <h6 id='active-filters-subtitle'>{labels.subtitle}</h6>
      )}
      <div className='active-filters-detail-box'>{getKeys()}</div>
    </div>
  )
}

ActiveFilters.defaultProps = {
  labels: {
    title: 'Active Filters',
    hide: 'Hide'
  }
}
ActiveFilters.propTypes = {
  /** This is an object that contains filter keys and an array of values */
  filters: PropTypes.object.isRequired,
  /** This is the object with the labels of the component, ready for the intl support **/
  labels: PropTypes.shape({
    title: PropTypes.string,
    hide: PropTypes.string
  })
}

export default ActiveFilters
